import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from 'react-i18next';
import Input from "../../../../../../components/input";
import {putRenameLabel} from "../../../../../../../actions/contactsGroupItemActions";
import Button from "../../../../../../components/button";
import Icon from "../../../../../../components/icon";
import {sharedWordRemove} from '../../../../../../utils';

function RenameLabelPopup () {

    const sharingDetailsPopup = useSelector( state => state.sharingDetailsReducer.getSharingDetailsPopup);

    const [labelNameValue, setLabelNameValue] = useState(sharedWordRemove(sharingDetailsPopup[2].labelName));
    const [isLabelRenamingProcessing, setIsLabelRenamingProcessing] = useState(false);

    const dispatch = useDispatch();

    const { t } = useTranslation();

    const handleChange = (e) => {
        if(document.getElementById('labelName').classList.contains('is-invalid')){
            document.getElementById('labelName').classList.remove('is-invalid');
        }
        setLabelNameValue(e.currentTarget.value);
    };

    const proceed = (e) => {
        e.preventDefault();

        if(labelNameValue.trim().length > 0){
            setIsLabelRenamingProcessing(true);
            dispatch(putRenameLabel(sharingDetailsPopup[2].labelId, labelNameValue));
        } else {
            document.getElementById('labelName').classList.add('is-invalid');
        }
    };

    return (
        <div className="new-label-popup p-3">
            <form method="post" onSubmit={ proceed }>
                <h2 className="mt-2 mb-0">{t("renameText")}</h2>
                <div className="py-3">
                    <Input
                        id="labelName"
                        type="text"
                        className="form-control"
                        placeholder={t("labelName")}
                        onChange={ handleChange }
                        value={labelNameValue}
                        required={true}
                        title={t("textEmptyField")}
                        aria-describedby="labelNameCheck"
                    />
                    <div id="labelNameCheck" className="invalid-feedback">
                        {t("textProvideNewLabel")}
                    </div>
                </div>
                <div className="text-right">
                    {
                        isLabelRenamingProcessing
                            ?
                            <Button disabled={true} className="btn-primary">
                                <Icon animated={'pulse'} name="spinner"/>
                            </Button>
                            :
                            <React.Fragment>
                                <Button type="submit" className="btn-primary">{t("textSave")}</Button>
                            </React.Fragment>
                    }
                </div>
            </form>
        </div>
    );

}

export default RenameLabelPopup;
